import __ from "./__";
import always from "./always";
import ifElse from "./ifElse";

const ifElseNull = ifElse(__, __, always(null));

export default ifElseNull;
